var map = {
	"./gift1.png": 7990,
	"./gift10.png": 843,
	"./gift11.png": 1695,
	"./gift12.png": 445,
	"./gift13.png": 2649,
	"./gift14.png": 5651,
	"./gift15.png": 5461,
	"./gift16.png": 5531,
	"./gift17.png": 628,
	"./gift18.png": 3522,
	"./gift19.png": 9140,
	"./gift2.png": 7016,
	"./gift20.png": 1460,
	"./gift21.png": 6738,
	"./gift22.png": 6945,
	"./gift23.png": 4391,
	"./gift24.png": 3540,
	"./gift3.png": 2583,
	"./gift4.png": 2368,
	"./gift5.png": 6834,
	"./gift6.png": 4954,
	"./gift7.png": 236,
	"./gift8.png": 7755,
	"./gift9.png": 8357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7865;